import { render, staticRenderFns } from "./NotificationComponents.vue?vue&type=template&id=0562ccda&"
import script from "./NotificationComponents.vue?vue&type=script&lang=js&"
export * from "./NotificationComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports